import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_ai_template} from "../components/templates/config_ai_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_ai extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected configAi: config_ai_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage() {
        this.getAiConfigReferences();
        this.getGeneralConfigData()

    }

    buildContent(): Array<Element> {
        this.configAi = new config_ai_template("config_ai", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Assistant Config");

        return [this.configAi.build()];
    }

    protected getModuleName(): string {
        return "config_ai";
    }

    private getGeneralConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/ai-settings/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let response = responseParsed.data;

                obj.configAi.setAiSettings(response.aiSettings);
                obj.configAi.setPermissions(response.permissions);

            });
        }
    }

     protected getAiConfigReferences() {
    // LOADING : starts
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/generalconfig/ai-settings/references/";
    let usrReq_params: Array<Array<string>> = [];
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
    this.XHRHdl.execute();
  }

   public filterMultipleSelectorOnChange(idElement = null) {
        this.configAi.updateSelectedContentTypes();
        this.configAi.updateSelectedArticleTypes();
        this.configAi.updateSelectedContentTypesSummary();
        this.configAi.updateSelectedArticleTypesSummary();
        this.configAi.updateSelectedContentTypesFAQ();
        this.configAi.updateSelectedArticleTypesFAQ();
    }


   protected onReferenceRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);

        let contentTypes = [...responseParsed.contentType];
        obj.configAi.setContentTypeOptions(contentTypes);




      });
    };
  }

    public filterDropdownOnChange(data) {
        // dropdowns cry without this, we don't really need it
    }

    protected getArticlesSuggestion(keyword, idElement) {
        if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
        }

        let subViewModel = { list: { keyword: keyword, sourceId: idElement } };

        let usrReq_url: string;

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);


            usrReq_url =
                "/api/brand/" +
                this.getVnAppZone().app.params.idBrand +
                "/search/article/";
          this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
          this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;


        this.XHRHdl.execute();
      }

        protected filterSimpleOnChange(idElement) {

        }

      protected onGetArticlesSuggestionsReturn(req, obj) {
        return function () {
          obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            let sourceId = JSON.parse(req._parameters[0][1])["list"]["sourceId"];

              obj.configAi.setArticlesFilter(responseParsed.data.articles);


          });
        };
      }

    protected analyzeArticleTitle(type){
        if(type=='both'){

            this.analyzeArticleByType('optimize');

        }
        else{
            this.analyzeArticleByType(type);
        }


    }

    protected analyzeArticleByType(type: string) {

      var buttonId = '';
      if (type != 'both' && type != 'optimize' && type != 'ctr') {
        buttonId = type+"-analysis-button";
      } else {
        buttonId = "title-analysis-button";
      }

      var endpoint = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/ai-tools/discover-optimize-title/get/";

      var button = document.getElementById(buttonId);
      if (button) {
        button.classList.add("is-generated");
      }

      var idBrand = this.getVnAppZone().app.params.idBrand;
      var idArticle = this.configAi.getTemplateViewModel().filterArticle.idArticle();

      var userMessage = "";
      if (type !== 'ctr') {
        var userMessages = document.querySelectorAll("#title-analysis-content-userMessage");
        if (userMessages.length > 0) {
          userMessage = userMessages[userMessages.length - 1].outerHTML;
        }
      }

      let prompt = '';

      if(type=='ctr'){
        prompt = this.configAi.getTemplateViewModel().titleDiscoverandOptimizePrompt();
      }
      else if(type=='optimize'){
        prompt = this.configAi.getTemplateViewModel().titleDiscoverandOptimizePrompt();
      }
      else if(type=='both'){
        prompt = this.configAi.getTemplateViewModel().titleDiscoverandOptimizePrompt();
      }
      else if(type=='seo'){
        prompt = this.configAi.getTemplateViewModel().seoSuggestionPrompt();
      }
      else if(type=='socialmedia'){
        prompt = this.configAi.getTemplateViewModel().socialmediaSuggestionPrompt();
      }
      else if(type=='thread'){
        prompt = this.configAi.getTemplateViewModel().threadSuggestionPrompt();
      }
      else if(type=='excerpt'){
        prompt = this.configAi.getTemplateViewModel().excerptSuggestionPrompt();
      }

      var data: any = {
        testMode: true,
        prompt: prompt,
        userMessage: userMessage,
        type: type,
        idArticle: idArticle

      };



      var formReq_params: Array<Array<string>> = [["data", JSON.stringify(data)]];

      this.XHRHdl = new XMLHttpRequestHandler(endpoint, formReq_params, this);
      this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      this.XHRHdl.onReadyStateFunction = this.onAnalyzeArticleReturn;
      this.XHRHdl.execute();
    }

    protected onAnalyzeArticleReturn(req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          var responseParsed = JSON.parse(req.request.response);

          if (responseParsed.data) {
            var type = responseParsed.type
            var containerId = "title-analysis-content-" + type;
            var parentContainer = document.getElementById("title-analysis-content");

            var contentEl = document.createElement("div");
            contentEl.id = containerId;

            if (parentContainer) {
              parentContainer.appendChild(contentEl);
            }

            document.querySelectorAll('.ai-scroll-spacer').forEach(function(spacer) {
              if (spacer && spacer.parentNode) {
                spacer.parentNode.removeChild(spacer);
              }
            });

            var aiThinking = document.querySelector('.ai-thinking');
            if (aiThinking && aiThinking.parentNode) {
              aiThinking.parentNode.removeChild(aiThinking);
            }

            obj.progressivelyReveal(contentEl, responseParsed.data, obj);

            setTimeout(function () {
              if (parentContainer) {
                var containerHeight = parentContainer.clientHeight;
                var contentHeight = contentEl.scrollHeight;

                if (contentHeight < containerHeight) {
                  var spacer = document.createElement("div");
                  spacer.className = "ai-scroll-spacer";
                  spacer.style.height = (containerHeight - contentHeight) + "px";
                  spacer.style.opacity = "0";
                  spacer.setAttribute("aria-hidden", "true");
                  parentContainer.appendChild(spacer);
                }
              }
            }, 0);


            if (type === 'optimize' ) {
                obj.configAi.addAiBotThinking();
                obj.analyzeArticleByType('ctr');

            } else if (type === 'ctr') {
                 var titleBtn = document.getElementById("title-analysis-button");
                if (titleBtn) {
                  titleBtn.classList.remove("is-generated");
                }
                 obj.configAi.getTemplateViewModel().isAiAnalyzing(false);
            }

            else if (type === 'image') {
              var imageBtn = document.getElementById("image-analysis-button");
              if (imageBtn) {
                imageBtn.classList.remove("is-generated");
              }
             obj.configAi.getTemplateViewModel().isAiAnalyzing(false);

            }else{
             let  buttonId = type+"-analysis-button";
              var button = document.getElementById(buttonId);
              if (button) {
                button.classList.remove("is-generated");
              }
               obj.configAi.getTemplateViewModel().isAiAnalyzing(false);
            }

          }
        });
      };
    }

    public initializeReadMoreBehavior(container) {
      const messageBlocks = container.querySelectorAll('.ai-userMessage');

      messageBlocks.forEach((block) => {
        const messageBody = block.querySelector('.message-body');
        const toggleBtn = block.querySelector('.read-more-btn');

        if (!messageBody || !toggleBtn) return;

        // Reset to collapsed state if needed
        messageBody.classList.add("truncated");
        toggleBtn.textContent = "Read More";

        toggleBtn.addEventListener("click", () => {
          const isExpanded = !messageBody.classList.contains("truncated");

          if (isExpanded) {
            messageBody.classList.add("truncated");
            toggleBtn.textContent = "Read More";
          } else {
            messageBody.classList.remove("truncated");
            toggleBtn.textContent = "Hide";
          }
        });
      });
    }

    protected saveAiSettings(param, data) {
        this.loadingIn(this.configAi.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/ai-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configAi.getAiSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {


           // let responseParsed = JSON.parse(req.request.response);
            // Render summaries
           // obj.renderSummaries(responseParsed);

            obj.manageResponse(req, obj, function () {

               let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                page.redirect("/brand/"+idBrand+"/config/assistant/");

            });
             obj.loadingOut(obj.configAi.builtTemplate);
            //  obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");

            }
        });
        XHRHdl.execute();
    }
    private renderSummaries(response: any): void {
        const container = document.getElementById("ai-summaries-container");
        if (!container) return;

        container.innerHTML = `
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Simple Summary</h4>
                <div class="ai-summary-content">${response.simpleSummary || ""}</div>
            </div>
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Factual Summary</h4>
                <div class="ai-summary-content">${response.factualSummary || ""}</div>
            </div>
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Satirical Commentary</h4>
                <div class="ai-summary-content">${response.satiricalCommentary || ""}</div>
            </div>

            <style>
                 .ai-summary-content {
                        background-color: $white;
                        border-radius: $border-radius-block;
                        padding: 1.25rem;
                        margin: 1rem;
                        position: relative;
                        transition: height .5s ease;

                        @include tablet {
                            padding: 1.75rem;
                            margin: 1.25rem;
                        }

                        @include dark-mode {
                            background-color: $theme-dark-body-bg-color;
                        }

                        .ai-summary  {
                            margin-top: 1.25rem;

                            /* Title */
                            h2 {
                                font-size: 1.5rem;
                                font-weight: 600;
                                margin-bottom: 1rem;
                            }

                            h3 {
                                font-size: 1.25rem;
                                font-weight: 500;
                                margin-bottom: 1rem;
                            }

                            p {
                                @include font-style(1rem, 400, $web-color-6);
                                line-height: 1.5;
                                margin-bottom: 1rem;

                                &:last-of-type {
                                    margin-bottom: 0;
                                }
                            }

                            ul, ol {
                                @include font-style(1rem, 400, $web-color-6);
                                line-height: 1.5;
                                padding-left: 1rem;
                                margin: 1.25rem;

                                li {
                                    margin-bottom: 0.5rem;
                                }
                            }

                            ul li {
                                list-style-type: disc;
                            }

                            ol li {
                                list-style-type: unset;
                            }


                            strong {
                                font-weight: bold;
                            }

                            em {
                                font-style: italic;
                            }

                            @include dark-mode {
                                * {
                                    color: $theme-dark-reading-text;
                                }
                            }
                        }

                        // Animation CSS
                        .hidden-remaining {
                            visibility: hidden;
                            opacity: 0;
                        }
                        .blurred-full {
                            filter: blur(20px);
                            color: transparent;
                            pointer-events: none;
                            user-select: none;
                        }
                        .blurred-current {
                            filter: blur(4px);
                            color: gray;
                            pointer-events: none;
                            user-select: none;
                        }
                    }

            </style>
        `;
    }

    protected cancelSiteSettings() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "AI SETTINGS changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/assistant/");
    }

     protected progressivelyReveal(div: HTMLElement, htmlContent: string,obj): void {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${htmlContent}</div>`, 'text/html');
  const root = doc.body.firstChild as HTMLElement;

  const textNodes: HTMLElement[] = [];

  function wrapTextNodes(node: Node): void {
    [...node.childNodes].forEach(child => {
      if (child.nodeType === Node.TEXT_NODE) {
        const span = document.createElement('span');
        span.className = 'blurred-full';
        span.textContent = child.textContent;
        node.replaceChild(span, child);
        (node as HTMLElement).classList.add('blurred-full');
        textNodes.push(span);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const el = child as HTMLElement;
        if (el.tagName === 'HR') {
          el.classList.add('blurred-full');
          textNodes.push(el);
        } else {
          wrapTextNodes(child);
        }
      }
    });
  }

  wrapTextNodes(root);
  div.innerHTML = '';
  div.appendChild(root);

  let nodeIndex = 0;
  let charIndex = 0;

  function revealNextChar(): void {

    if(nodeIndex >= textNodes.length) {
         obj.firstRevealComplete = true;
         return;
    };
    const node = textNodes[nodeIndex];

    const text = node.textContent || "";

    const jump = Math.ceil(text.length * (Math.random() * 0.01 + 0.01));

    if (charIndex >= text.length) {
      node.classList.remove('blurred-current', 'blurred-full');
      node.textContent = text;
      nodeIndex++;
      charIndex = 0;
      revealNextChar();
      return;
    }

    const parent = node.parentNode as HTMLElement;
    parent.classList.remove('blurred-current', 'blurred-full');

    const revealed = text.slice(0, charIndex + jump);
    const hidden = text.slice(charIndex + jump);
    node.innerHTML = `<span>${revealed}</span><span class="blurred-full">${hidden}</span>`;
    node.className = '';

    charIndex += jump;

    let delay = Math.max(8 - nodeIndex, 1);
    if (nodeIndex > textNodes.length * 0.8) delay = 1;

    setTimeout(revealNextChar, delay);
  }

  revealNextChar();
}
  protected typeText(element, html, speed = 50) {
    element.innerHTML = "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    let i = 0;
    function typeChar() {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(typeChar, speed);
      }
    }

    typeChar();
  }
}



// WEBPACK FOOTER //
// ./js/modules/config_ai.ts